import { motion } from "framer-motion";
import sigiri from "../../accests/sigiri/sigiri (11).jpeg";
import sigiri1 from "../../accests/sigiri/sigiri (10).jpeg";
import sigiri2 from "../../accests/sigiri/sigiri (5).jpeg";
import sigiri3 from "../../accests/sigiri/sigiri (1).jpeg";
import sigiri4 from "../../accests/sigiri/sigiri (9).jpeg";


// Unsplash Images
const heroImg =
    sigiri; // Sigiriya Rock


export default function SigiriyaAndDambullaDayTour() {

    const highlights = [
        {
            title: "Sigiriya Rock Fortress",
            desc: "Climb the iconic Lion Rock, a UNESCO World Heritage Site, featuring ancient frescoes, landscaped gardens, and breathtaking panoramic views from the summit.",
            img: sigiri,
        },
        {
            title: "Dambulla Cave Templee",
            desc: "Explore Sri Lanka’s largest cave temple complex, adorned with ancient murals and over 150 Buddha statues, including the famous reclining Buddha.",
            img: sigiri3,
        },

    ];

    const itinerary = [
        "Early morning pickup from your hotel",
        "Scenic drive to Sigiriya",
        "Guided climb of Sigiriya Rock Fortress",
        "Lunch at a local restaurant",
        "Visit Dambulla Cave Temple",
        "Time for photography and exploration",
        "Relaxing return journey to your hotel",
    ];

    return (
        <div className="pt-28 bg-gray-50">

            {/* HERO */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative h-[65vh]"
            >
                <img
                    src={heroImg}
                    alt="Sigiriya and Dambulla Day Tour"
                    className="w-full h-full object-cover brightness-75"
                />
                <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-6">
                    <motion.h1
                        initial={{ y: -40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.3 }}
                        className="text-5xl md:text-6xl font-bold drop-shadow-lg"
                    >
                        Sigiriya & Dambulla Day Tour
                    </motion.h1>
                    <motion.p
                        initial={{ y: 40, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1, delay: 0.6 }}
                        className="mt-4 max-w-3xl text-lg drop-shadow-md"
                    >
                        Explore two UNESCO World Heritage Sites in one unforgettable day
                        filled with history, culture, and breathtaking views.
                    </motion.p>
                </div>
            </motion.div>

            {/* INTRO */}
            <section className="max-w-5xl mx-auto px-6 py-16 text-center">
                <h2 className="text-3xl font-bold mb-6 text-gray-800">
                    Explore Two UNESCO World Heritage Sites
                </h2>
                <p className="text-gray-700 leading-relaxed">
                    Visiting a UNESCO World Heritage Site is special, but experiencing
                    two in one day is truly unforgettable. This cultural journey takes
                    you to Sigiriya’s majestic Lion Rock and the sacred Dambulla Cave
                    Temple, two of Sri Lanka’s most treasured landmarks.
                </p>
            </section>

            {/* HIGHLIGHTS */}
                <section className="max-w-7xl mx-auto px-6 py-16">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                        Tour Highlights
                    </h2>
                    <div className="grid md:grid-cols-2 gap-10">
                        {highlights.map((item) => (
                            <motion.div
                                key={item.title}
                                whileHover={{ scale: 1.05 }}
                                className="bg-white rounded-3xl shadow-lg overflow-hidden transition"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-64 object-cover"
                                />
                                <div className="p-6">
                                    <h3 className="text-2xl font-semibold text-yellow-500 mb-2">
                                        {item.title}
                                    </h3>
                                    <p className="text-gray-600 text-sm">
                                        {item.desc}
                                    </p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </section>


            {/* ITINERARY */}
            <section className="bg-gray-100 py-16">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-start">

                    {/* LEFT – ITINERARY LIST */}
                    <div>
                        <h2 className="text-3xl font-bold mb-10 text-gray-800">
                            Detailed Itinerary
                        </h2>

                        <ul className="space-y-4 text-gray-700 list-decimal list-inside">
                            {itinerary.map((step, index) => (
                                <motion.li
                                    key={index}
                                    initial={{ x: -50, opacity: 0 }}
                                    whileInView={{ x: 0, opacity: 1 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    className="text-lg"
                                >
                                    {step}
                                </motion.li>
                            ))}
                        </ul>
                    </div>

                    {/* RIGHT – SMALL IMAGES */}
                    <div className="grid grid-cols-2 gap-4">
                        {[sigiri2, sigiri3,sigiri1,sigiri].map((img, i) => (
                            <motion.img
                                key={i}
                                src={img}
                                alt="Tour spot"
                                whileHover={{ scale: 1.05 }}
                                className="h-40 w-full object-cover rounded-2xl shadow-lg"
                            />
                        ))}
                    </div>

                </div>
            </section>

            {/* WHY CHOOSE THIS TOUR + CTA */}
            <section className="relative py-24 overflow-hidden">

                {/* BACKGROUND IMAGE */}
                <div className="absolute inset-0">
                    <img
                        src={heroImg}
                        alt="Why choose Sigiriya & Dambulla tour"
                        className="w-full h-full object-cover scale-110 blur-md"
                    />
                    <div className="absolute inset-0 bg-black/60"></div>
                </div>

                {/* CONTENT */}
                <div className="relative max-w-6xl mx-auto px-6 text-white text-center">

                    <h2 className="text-3xl md:text-4xl font-bold mb-10">
                        Why Choose This Tour?
                    </h2>

                    {/* FEATURES */}
                    <ul className="max-w-3xl mx-auto space-y-4 text-lg list-disc list-inside backdrop-blur-md bg-white/10 p-8 rounded-3xl shadow-xl">
                        <li>Climb the iconic Sigiriya Rock Fortress with panoramic views.</li>
                        <li>Explore the sacred Dambulla Cave Temple with ancient murals and statues.</li>
                        <li>Experience two UNESCO World Heritage Sites in a single day.</li>
                        <li>Learn about Sri Lanka’s rich history from an expert local guide.</li>
                        <li>Enjoy hassle-free transport and a comfortable, well-planned itinerary.</li>
                    </ul>

                    {/* CTA */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        className="mt-14"
                    >
                        <motion.a
                            whileHover={{ scale: 1.08 }}
                            whileTap={{ scale: 0.95 }}
                            href="https://wa.me/94770163670?text=Hello%20I%20would%20like%20to%20book%20the%20Sigiriya%20%26%20Dambulla%20Day%20Tour"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center px-14 py-4
        bg-yellow-500 text-black font-semibold text-lg
        rounded-full shadow-xl hover:bg-yellow-400
        transition-all duration-300"
                        >
                            Book Sigiriya & Dambulla Day Tour
                        </motion.a>

                        <p className="mt-4 text-sm text-gray-200">
                            📞 Custom tours • 🕒 Flexible timing • 🚗 Comfortable transport
                        </p>
                    </motion.div>


                </div>
            </section>


            {/* TRAVEL TIPS */}
            <section className="bg-gray-50 py-20">
                <div className="max-w-6xl mx-auto px-6 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold mb-12 text-gray-800">
                        Travel Tips
                    </h2>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            className="bg-white p-6 rounded-3xl shadow-lg border border-gray-200 transition"
                        >
                            <div className="text-yellow-500 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2 text-gray-800">Comfortable Clothing</h3>
                            <p className="text-gray-600 text-sm">Wear comfortable clothes and sturdy shoes for climbing and walking tours.</p>
                        </motion.div>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            className="bg-white p-6 rounded-3xl shadow-lg border border-gray-200 transition"
                        >
                            <div className="text-yellow-500 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2 text-gray-800">Temple Etiquette</h3>
                            <p className="text-gray-600 text-sm">Cover knees and shoulders when visiting temples and sacred sites.</p>
                        </motion.div>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            className="bg-white p-6 rounded-3xl shadow-lg border border-gray-200 transition"
                        >
                            <div className="text-yellow-500 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2 text-gray-800">Sun Protection</h3>
                            <p className="text-gray-600 text-sm">Bring a hat, sunscreen, and sunglasses to stay protected under the sun.</p>
                        </motion.div>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            className="bg-white p-6 rounded-3xl shadow-lg border border-gray-200 transition"
                        >
                            <div className="text-yellow-500 mb-4">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2 text-gray-800">Stay Hydrated</h3>
                            <p className="text-gray-600 text-sm">Unlimited mineral water is provided to keep you refreshed throughout the tour.</p>
                        </motion.div>
                    </div>
                </div>
            </section>


        </div>
    );
}
